import * as editor from './editor.observer';
import * as elements from './elements.observer';
import * as metadata from './metadata.observer';

const configureObservers = (store) => {
  editor.configureObserver(store);
  elements.configureObserver(store);
  metadata.configureObserver(store);
};

export default configureObservers;
